import en from './Translations/en.json'
export default {
    en
}